import React from "react";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {Select} from "antd";
import {arrayAlphabeticalSort} from "utils/helpers";
import {normalizeStringSearchFilter} from "utils/helpers";

const DistrictInput = ({
    value,
    onChange,
    selectedCityId,
    selectedCityName,
    optionMappingKey = "_id",
    ...props
}) => {
    const stores = useStore();

    const [districtLoading, districts] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.optionStore.loadDistricts.bind(null, {
            cityId: selectedCityId,
            cityName: selectedCityName?.toLocaleLowerCase("tr-TR")
        }),
        condition: selectedCityId || selectedCityName,
        dependencies: [selectedCityId, selectedCityName]
    });

    return (
        <>
            <Select
                value={value}
                onChange={onChange}
                disabled={!selectedCityId && !selectedCityName}
                style={{width: "100%"}}
                mode="multiple"
                loading={districtLoading}
                data-testid="districtInput"
                allowClear
                showSearch
                filterOption={(input, option) =>
                    normalizeStringSearchFilter(option?.children ?? "").includes(
                        normalizeStringSearchFilter(input)
                    )
                }
                {...props}
            >
                {arrayAlphabeticalSort(districts, "name")?.map(district => (
                    <Select.Option
                        key={district?.[optionMappingKey]}
                        value={district?.[optionMappingKey]?.toLocaleLowerCase("tr-TR")}
                        data-testid="districtInput_option"
                    >
                        {district?.name}
                    </Select.Option>
                ))}
            </Select>
        </>
    );
};

export default DistrictInput;
